import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "kn-page-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_MondrianSchemasDetailTab = _resolveComponent("MondrianSchemasDetailTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_MondrianSchemasWorkflowTab = _resolveComponent("MondrianSchemasWorkflowTab")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-m-0" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.selectedSchema.name), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          icon: "pi pi-times",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.closeTemplateConfirm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_TabView, {
        class: "kn-tab kn-tab-overflow-visible",
        "data-test": "tab-view"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.mondrianSchemasManagement.detail.title')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_MondrianSchemasDetailTab, {
                selectedSchema: _ctx.selectedSchema,
                reloadTable: _ctx.reloadVersionTable,
                onFieldChanged: _ctx.onFieldChange,
                onActiveVersionChanged: _ctx.onVersionChange,
                onVersionUploaded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.versionToSave = $event)),
                onVersionsReloaded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reloadVersionTable = false))
              }, null, 8, ["selectedSchema", "reloadTable", "onFieldChanged", "onActiveVersionChanged"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.mondrianSchemasManagement.workFlow.title')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_MondrianSchemasWorkflowTab, {
                isChanged: _ctx.isWorkflowChanged,
                selectedSchema: _ctx.selectedSchema,
                usersList: _ctx.availableUsersList,
                onSelectedUsersChanged: _ctx.onSelectedUsersChange,
                onChanged: _ctx.emitTouched
              }, null, 8, ["isChanged", "selectedSchema", "usersList", "onSelectedUsersChanged", "onChanged"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}